import { render } from "./AdminRoster.vue?vue&type=template&id=a8857f8a&scoped=true&ts=true"
import script from "./AdminRoster.vue?vue&type=script&lang=ts"
export * from "./AdminRoster.vue?vue&type=script&lang=ts"

import "./AdminRoster.vue?vue&type=style&index=0&id=a8857f8a&scoped=true&lang=css"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8857f8a"]])

export default __exports__